import { toast } from "sonner";
import { CheckCircle2, Circle } from "lucide-react";
import { adminApi } from "@/lib/api";

export const AddonsAdmin = ({ c, onChanged }) => {
  if (!c.addons?.length) return null;
  const toggle = async (a) => {
    const status = a.status === "active" ? "todo" : "active";
    try { await adminApi.setAddonStatus(c.id, a.id, status); toast.success(status === "active" ? "Servizio attivato" : "Servizio da fare"); onChanged(); window.dispatchEvent(new Event("addons-changed")); }
    catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
  };
  return (
    <div data-testid="mc-addons" className="border border-[#E0262C]/40 bg-[#fdecec] p-3 space-y-1.5">
      <div className="text-[10px] uppercase tracking-widest font-mono text-[#E0262C]">Servizi da attivare</div>
      {c.addons.map((a) => (
        <button key={a.id} data-testid={`mc-addon-${a.id}`} onClick={() => toggle(a)}
          className="w-full flex items-center justify-between gap-3 text-left text-xs bg-white border border-[#d5dbde] px-3 py-2 hover:border-[#2B3036] transition-colors">
          <span className="flex items-center gap-2">
            {a.status === "active" ? <CheckCircle2 className="w-4 h-4 text-[#10b981]" /> : <Circle className="w-4 h-4 text-[#6b7280]" />}
            {a.qty > 1 && <b className="font-mono">{a.qty}×</b>} {a.name} <span className="font-mono text-[#6b7280]">· {(c.currency || "eur") === "chf" ? "CHF" : "€"} {a.price}</span>
          </span>
          <span className={`text-[10px] font-mono uppercase px-2 py-0.5 ${a.status === "active" ? "bg-[#10b981]/15 text-[#10b981]" : "bg-[#f59e0b]/15 text-[#b45309]"}`}>
            {a.status === "active" ? "attivo" : "da fare"}
          </span>
        </button>
      ))}
    </div>
  );
};
